import React from 'react';

import Tippy from '@tippyjs/react';

import numOrDefault from 'lib/helpers/numOrDefault';
import { mString } from 'lib/helpers/utility';

import Typography from 'components/shared/Typography/Typography';

const AmountPaidSelf = ({ value, data }) => {
  const baseAmount = numOrDefault(value);
  const surcharge = numOrDefault(data?.surcharge_amount);
  const refunded = numOrDefault(data?.amount_refunded);
  const refundedSurcharge = numOrDefault(data?.surcharge_refunded);

  const totalDisplay = mString(baseAmount + refunded);
  const isRefunded = refunded > 0 || refundedSurcharge > 0;
  const refundedDisplay = mString(refunded + refundedSurcharge);
  const chargeTooltip = mString(baseAmount + refunded - surcharge);
  const surchargeTooltip = mString(surcharge);

  return (
    <Tippy
      className="tippy-dark"
      content={
        <div className="flex flex-col gap-1">
          <Typography variant="span" size="small" color="white">
            Charge: <span>{chargeTooltip}</span>
          </Typography>
          <Typography variant="span" size="small" color="white">
            Technology fee: <span>{surchargeTooltip}</span>
          </Typography>
        </div>
      }>
      <div className="flex h-full items-center gap-1">
        <Typography variant="span" size="small" color="neutral-800">
          {totalDisplay}
        </Typography>
        {isRefunded && (
          <Typography variant="span" size="small" color="neutral-800">
            (Refunded:<span className="font-bold">-{refundedDisplay}</span>)
          </Typography>
        )}
      </div>
    </Tippy>
  );
};

export default AmountPaidSelf;
